<ng-container *transloco="let t">
  <button
    id="language-toggle"
    type="button"
    class="flex items-center gap-2 py-1 px-0 bg-transparent border-none text-ld-neutral-700 font-general text-base font-normal cursor-pointer transition-opacity duration-200 hover:opacity-80 focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2"
    [matMenuTriggerFor]="languageMenu"
    [attr.aria-label]="t('commonSelectLanguage')"
  >
    <mat-icon id="language-toggle-icon" class="w-6! h-6! text-2xl! leading-6! text-ld-neutral-700 shrink-0">
      language
    </mat-icon>
    <span id="language-toggle-label" class="whitespace-nowrap">{{ t('commonLanguages') }}</span>
  </button>
  <mat-menu #languageMenu="matMenu" id="language-menu" class="language-dropdown-menu">
    @for (lang of translationService.availableLanguages; track lang.code) {
      <button
        mat-menu-item
        [id]="'lang-' + lang.code"
        class="language-menu-item"
        [class.language-menu-item--active]="translationService.currentLanguage() === lang.code"
        [attr.aria-pressed]="translationService.currentLanguage() === lang.code"
        (click)="selectLanguage(lang.code)"
      >
        <span
          [id]="'lang-' + lang.code + '-label'"
          class="font-dm text-base leading-6 tracking-[0.04px]"
          [class.font-semibold]="translationService.currentLanguage() === lang.code"
          [class.text-ld-primary]="translationService.currentLanguage() === lang.code"
          [class.font-normal]="translationService.currentLanguage() !== lang.code"
          [class.text-ld-neutral-700]="translationService.currentLanguage() !== lang.code"
        >
          {{ lang.label }}
        </span>
      </button>
    }
  </mat-menu>
</ng-container>
